import { render, staticRenderFns } from "./grammar-tag.vue?vue&type=template&id=85f7f29a&"
import script from "./grammar-tag.vue?vue&type=script&lang=js&"
export * from "./grammar-tag.vue?vue&type=script&lang=js&"
import style0 from "./grammar-tag.vue?vue&type=style&index=0&id=85f7f29a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports